module.exports = __webpack_public_path__ + "static/media/dad-girl-mobile.3dbfc946.png";